import React from "react";
// import { Form } from "antd";

import { Modal } from "../../../core";
import CreateCompanyForm from "../../../components/addCompanyForm";

const AddCompany = ({ addCompanyModalOpen, getCompanies, closeModal }) => {
  // const [form] = Form.useForm();

  const closeModalHandler = () => {
    closeModal("addCompanyModal");
  };
  return (
    <Modal
      closable={true}
      visible={addCompanyModalOpen}
      //   onCreate={onCreate}
      okText="Add"
      maxwidth="568px"
      footer={false}
      //   onOk={oK}
      onCancel={closeModalHandler}
      //   onCancel={() => {
      //     dispatch({ type: "MODAL_VIEW", payload: false });
      //   }}
      tittle="Create New Company"
    >
      <CreateCompanyForm
        closeModal={closeModalHandler}
        getCompanies={getCompanies}
      />
    </Modal>
  );
};

export default AddCompany;
